// src/utils/copiaNF.js
// «📋 Copia per richiesta d'offerta» (W435): una sola copia in due formati — tabella vera per
// l'email (Gmail, Outlook), colonne separate da tabulazioni per Excel e testo ordinato per
// Blocco note o WhatsApp. Chi incolla prende da solo il formato giusto.
// Contenuto in utils/acquisti.js (copiaPerFornitore): mai prezzi né dati interni.
import { copiaPerFornitore } from "./acquisti";

export async function copiaNfPerFornitore(nf) {
  const { testo, html } = copiaPerFornitore(nf);
  return copiaTestoHtml(testo, html);
}

/** Copia negli appunti lo stesso contenuto come testo (Excel, WhatsApp) e come HTML (email). */
export async function copiaTestoHtml(testo, html) {
  try {
    if (navigator.clipboard && window.ClipboardItem) {
      await navigator.clipboard.write([new window.ClipboardItem({
        "text/plain": new Blob([testo], { type: "text/plain" }),
        "text/html": new Blob([html], { type: "text/html" }),
      })]);
      return true;
    }
  } catch { /* alcuni browser accettano solo il testo: si prova sotto */ }
  try { await navigator.clipboard.writeText(testo); return true; } catch { /* sotto il ripiego */ }
  // Ultimo ripiego (browser vecchi o pagina non sicura): copia da un campo nascosto
  try {
    const ta = document.createElement("textarea");
    ta.value = testo; ta.style.position = "fixed"; ta.style.opacity = "0";
    document.body.appendChild(ta); ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch { return false; }
}
